import { useQuery } from "@tanstack/react-query";

import {
  getDeActivatedEstimatesBySiteId,
  getSiteById,
  getSites,
  getIntensity,
  getIntensitysite,
  getSitesWithPagination,
} from "api";
import { SiteDTO, IntensityDTO, SiteByIdDTO, EstimateDTO, SitesPaginatedQuery, SitesPaginatedData, SitesPaginatedRequestBody } from "api/sites/types";

import { QUERY_KEYS } from "consts";

import { MaybeNull } from "types";

export const useSites = () => useQuery<SiteDTO[]>([QUERY_KEYS.SITES], getSites);
export const useSitesPaginated = (query: SitesPaginatedQuery, requestBody?: SitesPaginatedRequestBody) =>
  useQuery<SitesPaginatedData>(
    [QUERY_KEYS.SITES_PAGINATED, query, requestBody],
    () => getSitesWithPagination(query, requestBody),
    { keepPreviousData: true }
  );
export const useIntensitycompany = () => useQuery<IntensityDTO[]>([QUERY_KEYS.INTENSITY], getIntensity);
export const useIntensitysite = () => useQuery<IntensityDTO[]>([QUERY_KEYS.INTENSITYSITE], getIntensitysite);

export const useSiteById = (id: number, enabled: boolean = true) =>
  useQuery<SiteByIdDTO>([QUERY_KEYS.SITES, id], () => getSiteById(id), {
    enabled,
  });

export const useDeActivatedEstimatesBySiteId = (siteId: MaybeNull<number>) =>
  useQuery<EstimateDTO[]>(
    [QUERY_KEYS.ESTIMATES, QUERY_KEYS.SITES, siteId],
    () => getDeActivatedEstimatesBySiteId(siteId!),
  );
